jQuery( document ).ready(function() {
    jQuery('.navbar .dropdown-menu a.dropdown-toggle').on('click', function(e) {
        $(this).addClass('current-dropwdown');
        if (!jQuery(this).next().hasClass('show')) {
            jQuery(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = jQuery(this).next(".navbar .dropdown-menu");
        $subMenu.toggleClass('show');

        jQuery(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            jQuery('.dropdown-submenu .show').removeClass("show");
            $('.dropdown-menu a.dropdown-toggle').removeClass('current-dropwdown');
        });
        return false;
    });

    jQuery("#toggle-menu").click(function () {
        $(".navbar").toggleClass('active');
        $( ".navbar-nav" ).toggleClass('hide');
    });

    jQuery("#search a").click(function (e) {
        e.preventDefault();
        var input = $( "#searchContent" );
        
        input.toggleClass('hide').focus();
        $('i', this).toggleClass('icon-cursor icon-magnifier');
		
		if(input.val()){
			$('#searchForm').submit();
		}
	});
	
	jQuery("#search input").on('focusout',function (e) {
		var $this = $(this);
		if(!$this.val()){
			$this.toggleClass('hide');
			$('i', this).toggleClass('icon-cursor icon-magnifier');
		}
	});
    
    
    $('.dropdown').on('show.bs.dropdown', function () {
        $(this).parents('.item-content').addClass('active');
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/nav.js